var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Login"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M15.8144 12.0234H3.77344",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3",
    d: "M12.8867 9.10547L15.8147 12.0215L12.8867 14.9375",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-4",
    d: "M8.50781 7.39044V6.45744C8.50781 4.42244 10.1568 2.77344 12.1928 2.77344H17.0768C19.1068 2.77344 20.7518 4.41844 20.7518 6.44844V17.5884C20.7518 19.6234 19.1018 21.2734 17.0668 21.2734H12.1818C10.1528 21.2734 8.50781 19.6274 8.50781 17.5984V16.6564",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSignout);
export default __webpack_public_path__ + "static/media/darkSignout.48ad7b311535d5e3c8d36efbbcb561f9.svg";
export { ForwardRef as ReactComponent };